<template>
  <div v-if="hasBanners" class="leaderboard__header">
    <div class="top-banners">

      <div v-if="appearances.sponsor_logo_1" class="banner logo">
        <a v-if="appearances.sponsor_logo_1_link" :href="appearances.sponsor_logo_1_link" target="_blank">
          <img :src="`${appearances.sponsor_logo_1}`" />
        </a>
        <img v-else :src="`${appearances.sponsor_logo_1}`" />
      </div>

      <div v-if="appearances.sponsor_logo_2" class="banner logo">
        <a v-if="appearances.sponsor_logo_2_link" :href="appearances.sponsor_logo_2_link" target="_blank">
          <img :src="`${appearances.sponsor_logo_2}`" />
        </a>
        <img v-else :src="`${appearances.sponsor_logo_2}`" />
      </div>
    </div>

    <div v-if="appearances.sponsor_logo_3" class="banner">
      <a v-if="appearances.sponsor_logo_3_link" :href="appearances.sponsor_logo_3_link" target="_blank">
        <img :src="`${appearances.sponsor_logo_3}`" />
      </a>
      <img v-else :src="`${appearances.sponsor_logo_3}`" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppearancesDraftsHeader',
  props: {
    appearances: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasBanners() {
      return this.appearances.sponsor_logo_1 ||
             this.appearances.sponsor_logo_2 ||
             this.appearances.sponsor_logo_3
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/AppearancesDraftsHeader.vue